import en from '@/i18n/en.json';
import zhCN from '@/i18n/zh-CN.json';
import { createI18n } from 'vue-i18n';

export const i18n = createI18n<[typeof zhCN], 'zh-CN' | 'en'>({
  legacy: false,
  locale: 'zh-CN',
  messages: {
    'zh-CN': zhCN,
    en
  }
});